import translator from '@/locales';
import { convertArrayOfPrimitiveToHashTable } from '@/utils/arrayToHashTable';

export const rangeFilters = [
  {
    value: 'all-time',
    label: translator.t('ALL'),
  },
  {
    value: 'today',
    label: translator.t('RANGE.TODAY'),
  },
  {
    value: 'yesterday',
    label: translator.t('RANGE.YESTERDAY'),
  },
  {
    value: 'last-week',
    label: translator.t('APP.STATS.FILTERS.RANGE.LAST_WEEK'),
  },
  {
    value: 'last-month',
    label: translator.t('APP.STATS.FILTERS.RANGE.LAST_MONTH'),
  },
  {
    value: 'last-three-months',
    label: translator.t('APP.STATS.FILTERS.RANGE.LAST_THREE_MONTHS'),
  },
  {
    value: 'last-six-months',
    label: translator.t('APP.STATS.FILTERS.RANGE.LAST_SIX_MONTHS'),
  },
];

export function getFilters(selectedRanges = []) {
  if (!Array.isArray(selectedRanges))
    throw new Error('selected ranges should be an array.');

  if (!selectedRanges.length) return rangeFilters;
  const selectedRangeHashTables = convertArrayOfPrimitiveToHashTable(
    selectedRanges,
  );
  return rangeFilters.filter(({ value }) => value in selectedRangeHashTables);
}
